import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  Dialog,
  DialogActions,
  Button,
  withMobileDialog,
  DialogContent,
} from '@material-ui/core'
import { toggleModal, setPhoneState } from 'actions/phone'
import { call } from 'actions/inbox'
import { getClientToken, getClientTokenSchema } from 'actions/voice'
import { Device } from 'twilio-client'
import contactLabel from 'utils/contactLabel'
import { IconButton } from '@material-ui/core'
import { Phone, MicOff } from '@material-ui/icons'
// import { Link } from 'react-router-dom'
import secondsToDhms from 'utils/secondsToDhms'

const styles = (theme) => ({})

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const LogBox = ({ text }) => (
  <div>
    <div style={{ fontSize: 16, minHeight: 19 }}>{text}</div>
  </div>
)

class PhoneCallDialog extends Component {
  state = { time: 0 }

  componentDidUpdate(prevProps) {
    if (this.props.onPhone !== prevProps.onPhone && this.props.onPhone) {
      console.log(
        'this.props.onPhone !== prevProps.onPhone && this.props.onPhone',
      )
      this.startCall()
    }

    if (this.props.onPhone !== prevProps.onPhone && !this.props.onPhone) {
      console.log(
        'this.props.onPhone !== prevProps.onPhone && !this.props.onPhone',
      )
      this.endCall()
    }

    if (this.props.startTime !== prevProps.startTime && this.props.startTime) {
      console.log(
        'this.props.startTime !== prevProps.startTime && this.props.startTime',
      )
      this.timerID = setInterval(() => this.tick(), 1000)
    }

    if (this.props.muted !== prevProps.muted) {
      console.log('this.props.muted !== prevProps.muted && this.props.muted')

      if (!jwtToken) {
        try {
          this.device.activeConnection().mute(this.props.muted)
        } catch (e) {
          console.log(e)
        }
      } else {
        window.ReactNativeWebView &&
          window.ReactNativeWebView.postMessage(
            this.props.muted ? 'mute' : 'unmute',
          )
      }
    }
  }

  componentWillUnmount() {
    // console.log('<PhoneCall /> componentWillUnmount')
    this.setState({ time: 0 })
    this.props.setPhoneState({
      onPhone: false,
      muted: false,
      log: null,
      startTime: null,
    })
    clearInterval(this.timerID)
  }

  tick() {
    if (this.props.startTime) {
      this.setState({
        time: Math.floor((Date.now() - this.props.startTime) / 1000),
      })
    }
  }

  setDeviceHandlers = () => {
    // console.log('<PhoneCall /> setDeviceHandlers')
    var self = this

    if (this.device) {
      // console.log('hits setDeviceHandlers() if this.device')
      try {
        this.device.audio.availableOutputDevices.forEach(function (device, id) {
          console.log(device)
          if (id === 'default') {
            // console.log('hits if (id === default')
            this.device.audio
              .setInputDevice('default')
              .then(() => console.log('successfully setInputDevice'))
          }
        })
      } catch (e) {
        console.log(e)
      }

      try {
        this.device.on('disconnect', () => {
          clearInterval(self.timerID)

          self.props.setPhoneState({
            onPhone: false,
            log: null,
            startTime: null,
            to: null,
            modalOpen: false,
          })
        })
      } catch (e) {
        console.log(e)
      }

      try {
        this.device.on('connect', (connection) => {
          // console.log('.on(connect)')
          // console.log('connection:')
          // console.log(connection)

          // console.log(connection.status())

          // connection.on('accept', () => console.log('connection on accept'))
          // connection.on('cancel', () => console.log('connection on cancel'))
          // connection.on('reject', () => console.log('connection on reject'))
          // connection.on('mute', () => console.log('connection on mute'))
          // connection.on('ringing', () => console.log('connection on ringing'))

          // this.timerID = setInterval(() => this.tick(), 1000)
          this.props.setPhoneState({ startTime: Date.now() })
        })
      } catch (e) {
        console.log(e)
      }
    }
  }

  startCall = () => {
    // console.log('<PhoneCallDialog /> startCall()')

    const {
      selectedFromNumber,
      to,
      account_id,
      contact_id,
      vastUserName,
      contact,
      getClientToken,
    } = this.props

    if (!jwtToken) {
      if (this.device) {
        try {
          this.device.destroy()
        } catch (e) {
          console.log(e)
        }
      }
    }

    getClientToken().then((tokenPayload) => {
      if (tokenPayload && tokenPayload.twilio_token && !jwtToken) {
        try {
          this.device = new Device()
        } catch (e) {
          console.log(e)
        }

        if (this.device) {
          // console.log('hits startCall() if this.device')
          this.device.setup(tokenPayload.twilio_token)
          var self = this
          this.device.on('ready',function(device){
            console.log('this.device:')
            console.log(self.device)

            self.setDeviceHandlers()
         
            if (selectedFromNumber && selectedFromNumber.phone_number && to) {
              if (account_id && contact_id && vastUserName) {
                const payload = {
                  number: to,
                  from_number: selectedFromNumber.phone_number,
                  account_id,
                  contact_id,
                  vastUserName,
                }
                self.device.connect(payload)
              }
              self.props.call()
            }
          })
          Promise.resolve(this.device.setup(tokenPayload.twilio_token)).then(
            () => {
             
            },
          )
        }
      } else if (tokenPayload && tokenPayload.twilio_token) {
        window.ReactNativeWebView &&
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              payload: {
                number: to,
                from_number: selectedFromNumber.phone_number,
                account_id,
                contact_id,
                vastUserName,
              },
              token: tokenPayload.twilio_token,
              contactLabel: contactLabel(contact),
            }),
          )
      } else {
        console.log('no payload.twilio_token', tokenPayload)
      }
    })
  }

  endCall = () => {
    // console.log('<PhoneCall /> endCall()')
    // this.props.setPhoneState({ startTime: null, to: null })

    if (!jwtToken) {
      try {
        this.device.destroy()
      } catch (e) {
        console.log(e)
      }
    } else {
      window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage('endCall')
    }
  }

  toggleCall = () => {
    // console.log('<PhoneCall /> toggleCall()')
    this.props.toggleModal(true)

    if (this.props.onPhone) {
      this.props.setPhoneState({ onPhone: false, muted: false })
    } else {
      this.props.setPhoneState({ onPhone: true, muted: false })
    }
  }

  render() {
    return (
      <Dialog
        fullWidth
        fullScreen={this.props.fullScreen}
        open={this.props.modalOpen}
        onClose={() => this.props.toggleModal(false)}
      >
        <DialogContent>
          <div
            style={{
              height: 110,
            }}
          >
            {/* <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
              <Link to="/managephones">Manage phones</Link>
            </div> */}
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            ></div>
            <div
              style={{
                margin: '10px auto 0',
                width: '50%',
                textAlign: 'center',
              }}
            >
              <div style={{ fontSize: 22, minHeight: 25 }}>
                {this.props.onPhone ? secondsToDhms(this.state.time) : null}
              </div>
              <IconButton
                disabled={!this.props.onPhone}
                onClick={() => {
                  this.props.setPhoneState({ muted: !this.props.muted })
                }}
                style={{
                  backgroundColor: this.props.muted ? 'gray' : 'transparent',
                  color: this.props.muted ? '#fff' : 'gray',
                }}
              >
                <MicOff />
              </IconButton>
              <IconButton
                onClick={() => this.toggleCall()}
                style={{
                  backgroundColor: this.props.onPhone ? 'red' : '#19B940',
                  color: '#fff',
                }}
              >
                <Phone />
              </IconButton>
              <LogBox text={this.props.log} />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => this.props.toggleModal(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default connect(
  (state) => ({
    modalOpen: state.phone.modalOpen,
    onPhone: state.phone.onPhone,
    muted: state.phone.muted,
    startTime: state.phone.startTime,
    log: state.phone.log,
    token: state.voice.token,
    to: state.inbox.to.current.value,
    selectedFromNumber: state.inbox.fromNumberSelected,
    account_id:
      state.AccountSettings &&
      state.AccountSettings.settings &&
      state.AccountSettings.settings.id,
    contact_id:
      (state.inbox.contactSelected && state.inbox.contactSelected.id) ||
      state.inbox.conversationSelected,
    contact:
      (state.inbox.contactSelected || state.inbox.conversationSelected) &&
      state.contacts.contactsWithEmailsByID[
        state.inbox.contactSelected || state.inbox.conversationSelected
      ],
    vastUserName:
      state.auth.session &&
      state.auth.session.idToken &&
      state.auth.session.idToken.payload &&
      state.auth.session.idToken.payload['cognito:username'],
  }),
  (dispatch) =>
    bindActionCreators(
      {
        toggleModal,
        call,
        getClientToken,
        getClientTokenSchema,
        setPhoneState,
      },
      dispatch,
    ),
)(withStyles(styles)(withMobileDialog()(PhoneCallDialog)))
